
import axios from 'axios'
import chromeError from './errCode'

// 在非 vue 页面，需要单独引入element
import {ElMessage,ElMessageBox} from 'element-plus'
import { Action } from 'element-plus'


let msgSystemError = 'Sorry, system error. Please send us an email to solve your problem. email: {0}, error code: {1}';

// 网络请求基础配置
const baseAxios = axios.create({
    // baseURL: 'http://192.168.3.44:8081',
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout:10000
})

baseAxios.interceptors.response.use(res=>{

    // 请求失败
    if(res.status !== 200){
        console.log("res.data=",res.data)
        alertErrMsg(chromeError.httpStatusIsNotNormal)
        return ;
    }

    // 业务异常
    if(res.data.errCode!='E0000'){
        console.log("业务异常=",res.data)
        alertBusinessErrMsg(res.data.errMsg)
        return res;
    }

    console.log("正常返回：res=",res)
    // 正常返回
    return res;
},error => {
    console.log("请求发生异常,",error)
    alertErrMsg(error);
    return error;
})


/**
 * 封装弹窗的错误信息
 * @param chromeError
 */
function alertErrMsg(chromeError){
    let errCodeStr = chromeError.errCode || chromeError.code;
    let errMsg = msgSystemError.signMix("xajiaai@google.com",errCodeStr);
    ElMessageBox.alert(errMsg, 'Error Message', {
        confirmButtonText: 'OK'
    });
}

function alertBusinessErrMsg(errMsg){
    ElMessageBox.alert(errMsg, 'Error Message', {
        confirmButtonText: 'OK'
    });
}

/**
 * 增加字符串替换功能
 * @returns {String}
 */
String.prototype.signMix= function() {
    if(arguments.length === 0) return this;
    let param = arguments[0], str= this;
    if(typeof(param) === 'object') {
        for(let key in param){
            str = str.replace(new RegExp("\\{" + key + "\\}", "g"), param[key]);
        }
        return str;
    }
    for(let i = 0; i < arguments.length; i++) {
        str = str.replace(new RegExp("\\{" + i + "\\}", "g"), arguments[i]);
    }
    return str;

}

/**
 * 封装get请求
 * @param url
 * @param params
 * @returns {*}
 */
function get(url,params){
    let requestParam = join(params);
    return baseAxios.get(url+requestParam);
}

/**
 * 携带回调函数的get请求
 * @param url
 * @param params
 * @param callback
 * @returns {*}
 */
function getCallback(url,params,callback){
    return get(url,params).then(res=>{
        callback(res);
    })
}

/**
 * 普通 post请求
 * @param url
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
function post(url,params){
    return baseAxios.post(url,params,{
        transformRequest: join,
        headers: baseHeaders
    })
}

/**
 * 带回调函数的post请求
 * @param url
 * @param params
 * @param callback
 * @returns {Promise<AxiosResponse<any>>}
 */
function postCallback(url,params,callback){
    return post(url,params).then(res=>{
        callback(res);
    })
}

// 接触的header配置
const baseHeaders = {
    'Content-Type': 'application/x-www-form-urlencoded'
}


/**
 * form 表单数据，替换为 k=v&k2=v2的形式，同时进行 encode
 * @param data
 */
function join(data){
    let str = '';
    for(let key in data){
        str += encodeURIComponent(key) + '=' + encodeURIComponent(data[key]) + '&';
    }
    console.log(str);
    return str;
}

export default {post,postCallback,join,get,alertErrMsg,alertBusinessErrMsg}

